import {
  CreditCard,
  Envelope,
  GearSix,
  Globe,
  Path,
  type Icon,
} from "@phosphor-icons/react";

export type AdminSettingsSection =
  | "platform"
  | "pricing"
  | "billing"
  | "therapist-onboarding"
  | "communication";

export type AdminSettingsTab = "questionnaire" | "specializations";

export interface AdminSettingsSearch {
  section: AdminSettingsSection;
  tab?: AdminSettingsTab;
}

export interface AdminSettingsSectionConfig {
  key: AdminSettingsSection;
  label: string;
  description: string;
  icon: Icon;
}

export const DEFAULT_ADMIN_SETTINGS_SECTION: AdminSettingsSection = "platform";

export const ADMIN_SETTINGS_SECTIONS: AdminSettingsSectionConfig[] = [
  {
    key: "platform",
    label: "Platforma",
    description: "Pravila i osnovni podaci",
    icon: GearSix,
  },
  {
    key: "pricing",
    label: "Cijene",
    description: "Multiplikatori i provizija",
    icon: Globe,
  },
  {
    key: "billing",
    label: "Naplata",
    description: "Pretplate i računi",
    icon: CreditCard,
  },
  {
    key: "therapist-onboarding",
    label: "Onboarding",
    description: "Upitnik i specijalizacije",
    icon: Path,
  },
  {
    key: "communication",
    label: "Komunikacija",
    description: "Email template-i",
    icon: Envelope,
  },
];

export const SECTION_TABS: Partial<Record<AdminSettingsSection, AdminSettingsTab[]>> = {
  "therapist-onboarding": ["questionnaire", "specializations"],
};

export function isAdminSettingsSection(value: unknown): value is AdminSettingsSection {
  return typeof value === "string" && ADMIN_SETTINGS_SECTIONS.some((section) => section.key === value);
}

function isAdminSettingsTabForSection(
  section: AdminSettingsSection,
  value: unknown,
): value is AdminSettingsTab {
  return typeof value === "string" && (SECTION_TABS[section] ?? []).includes(value as AdminSettingsTab);
}

export function defaultTabForSection(section: AdminSettingsSection): AdminSettingsTab | undefined {
  return SECTION_TABS[section]?.[0];
}

export function parseAdminSettingsSearch(search: Record<string, unknown>): AdminSettingsSearch {
  const section = isAdminSettingsSection(search.section)
    ? search.section
    : DEFAULT_ADMIN_SETTINGS_SECTION;
  const tab = isAdminSettingsTabForSection(section, search.tab)
    ? search.tab
    : undefined;
  return tab ? { section, tab } : { section };
}
